import React, { Component } from "react";

class Index extends Component {
  render() {
    return <div></div>;
  }
}

export default Index;
